import React from 'react';
import MedicalBillingApp from './components/MedicalBillingApp';

function App() {
  return (
    <div className="App">
      <MedicalBillingApp />
    </div>
  );
}

export default App;